.page {
  padding: 60px 20px;
  max-width: 860px;
  margin: 0 auto;
}

.title {
  font-size: 2rem;
  margin-bottom: 8px;
  color: var(--color-text-primary);
}

.subtitle {
  color: var(--color-text-muted);
  margin-bottom: 36px;
}

/* ── Two-column layout ─────────────────────────────────────── */

.columns {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.column {
  flex: 1;
  min-width: 0;
}

.columnTitle {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;
  max-height: 480px;
  overflow-y: auto;
}

.listItem {
  display: block;
  width: 100%;
  text-align: left;
  background: var(--color-bg-secondary);
  border: none;
  border-bottom: 1px solid var(--color-border);
  padding: 12px 16px;
  cursor: pointer;
  color: var(--color-text-primary);
  font-size: 0.9375rem;
  font-family: inherit;
  transition: background-color 0.15s;
}

.listItem:last-child {
  border-bottom: none;
}

.listItem:hover:not(:disabled) {
  background-color: var(--color-bg-tertiary);
}

.listItemSelected {
  font-weight: 700;
  color: var(--color-accent);
  background-color: var(--color-bg-tertiary);
}

.listItemDisabled {
  opacity: 0.4;
  cursor: default;
}

/* ── Go button ──────────────────────────────────────────────── */

.goRow {
  margin-top: 28px;
  display: flex;
  justify-content: center;
}

.goBtn {
  background-color: var(--color-accent);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 40px;
  font-size: 1rem;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.2s;
}

.goBtn:disabled {
  opacity: 0.35;
  cursor: default;
}

.goBtn:not(:disabled):hover {
  opacity: 0.88;
}

/* ── Status messages ────────────────────────────────────────── */

.loading {
  color: var(--color-text-muted);
}

.error {
  color: var(--color-text-secondary);
}

.empty {
  color: var(--color-text-muted);
  margin-top: 24px;
}
